import styled from "styled-components";
import { color, spacing } from "@conserveit/blocks";

export const Container = styled.div`
  width: 600px;
  padding: ${spacing.loose};
`;

export const Hr = styled.hr`
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid ${color.theme.divider.solid};
`;
